var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPik1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 514,
    viewBox: "0 0 451 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390.556 241.032C377.831 219.169 382.713 173.149 382.713 173.149L379.846 175.77C392.602 142.402 381.923 128.928 381.923 128.928C350.442 82.0554 303.323 113.051 303.323 113.051C303.323 113.051 268.758 118.57 281.546 159.908C282.321 162.42 282.646 165.474 282.739 168.668C282.631 169.04 277.299 188.639 275.392 192.314C274.013 194.981 280.941 198.656 284.956 200.516C293.914 239.636 295.929 238.256 295.929 238.256C311.755 239.016 324.356 236.427 334.555 231.837C335.966 239.202 337.407 247.11 337.407 247.11C340.801 274.042 302.796 291.377 302.796 291.377L374.948 318.636L446.634 272.88C446.634 272.88 406.087 267.67 390.571 241.032H390.556Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7354 481.333L270.913 459.409L411.031 498.56L411.682 508.53L170.505 530.454L30.3864 491.303L29.7354 481.333Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2762 482.248L272.571 468.386L236.441 320.124L5.47803 330.9L36.2762 482.248Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.259 330.559C131.631 332.187 130.81 333.753 129.43 334.063C128.051 334.374 126.625 333.319 126.253 331.691C125.881 330.063 126.702 328.497 128.082 328.187C129.461 327.877 130.887 328.931 131.259 330.559Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4779 330.9L236.441 320.124L5.4779 330.9L36.2761 482.248L29.7506 481.597L1.10693 335.49L5.4779 330.9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4779 330.9L236.441 320.124L5.4779 330.9ZM5.4779 330.9L36.2761 482.248L29.7506 481.597L1.10693 335.49L5.4779 330.9Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3491 342.964L225.343 333.428L252.235 450.602L49.4508 468.805L23.3491 342.964Z",
    fill: "#EC7C1C",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7354 481.333L169.854 520.484L411.031 498.56L270.913 459.409L29.7354 481.333Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.786 503.971L63.9434 484.45L270.339 465.688L338.182 484.651L133.786 503.971Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8232 488.621L285.963 470.061",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2295 493.52L303.354 474.96",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.62 498.42L320.744 479.86",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9136 482.45L157.345 501.49",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.055 480.434L180.486 499.474",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.941 478.496L200.373 497.536",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.812 476.558L220.244 495.598",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.698 474.619L240.114 493.66",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.468 472.929L260.001 491.722",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.261 470.976L280.476 489.954",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.504 469.13L300.378 488.016",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M253.057 467.378L320.233 486.078",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M134.157 358.764L209.983 354.205C210.587 354.174 211.114 354.577 211.269 355.166L218.818 385.479C219.004 386.239 218.477 386.983 217.702 387.045L155.268 391.635C154.989 391.666 154.726 391.774 154.524 391.961L144.961 403.016C144.217 403.683 143.039 403.279 142.868 402.287L132.979 360.268C132.84 359.508 133.398 358.795 134.173 358.764H134.157Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.627 415.885L223.654 409.869L228.862 427.84L225.235 428.227L221.685 428.615L150.277 435.019L145.627 415.885Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.662 434.895L114.302 359.306L59.9441 361.57L52.1787 366.64L68.6085 445.888L123.896 439.981L131.662 434.895Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9443 361.57L114.302 359.306L131.662 434.895L76.3742 440.802L59.9443 361.57Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6084 445.888L76.3738 440.802",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7954 360.082L98.6784 375.572C98.7559 375.975 99.2829 376.083 99.5154 375.742L101.98 372.098C102.166 371.819 102.553 371.773 102.817 371.99L106.196 374.843C106.537 375.122 107.033 374.827 106.94 374.393L103.7 359.756L95.8109 360.082H95.7954Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3115 394.069L112.411 391.402",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4272 401.388L113.542 398.736",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.274 368.206L173.744 367.369",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M162.63 373.261L205.27 371.028",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.312 378.58L205.953 376.362",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.749 373.308C156.555 376.858 154.757 380.301 151.734 380.983C148.712 381.68 145.596 379.355 144.79 375.804C143.984 372.253 145.782 368.811 148.805 368.129C151.827 367.431 154.943 369.757 155.749 373.308Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.469 422.304C155.671 423.204 155.221 424.072 154.446 424.258C153.671 424.429 152.896 423.839 152.679 422.94C152.478 422.041 152.927 421.172 153.702 420.986C154.477 420.816 155.252 421.405 155.469 422.304Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.081 421.669C161.282 422.568 160.833 423.436 160.058 423.622C159.283 423.793 158.508 423.204 158.291 422.304C158.089 421.405 158.539 420.537 159.314 420.351C160.089 420.18 160.864 420.769 161.081 421.669Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.707 421.033C166.909 421.932 166.459 422.801 165.684 422.987C164.909 423.157 164.134 422.568 163.917 421.669C163.716 420.769 164.165 419.901 164.94 419.715C165.715 419.544 166.49 420.134 166.707 421.033Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M444.247 285.982C444.247 285.982 441.101 268.926 439.396 328.544C437.815 384.348 437.195 442.911 437.195 442.911C437.195 442.911 406.97 443.795 374.622 457.92L353.682 466.619C353.682 466.619 408.04 496.73 446.727 508.762C482.346 519.833 485.694 492.621 481.447 426.507C481.447 426.507 461.188 290.695 444.232 285.997L444.247 285.982Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M301.292 98.5532C301.292 98.5532 255.878 122.788 281.871 147.116L312.731 116.26L301.292 98.5532Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M369.197 214.657C369.197 214.657 379.412 214.394 385.519 228.224C385.519 228.224 378.823 212.517 390.51 199.524L369.213 214.657H369.197Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M301.292 98.5531C301.292 98.5531 245.741 152.977 279.035 137.72C348.598 105.856 345.033 186.143 345.033 186.143C345.033 186.143 354.612 177.413 351.078 186.546L369.197 214.641C369.197 214.641 407.931 199.989 409.993 151.194C410.69 134.711 394.493 59.1385 301.292 98.5531Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M325.131 130.835C326.169 139.162 325.131 172.421 339.825 174.855C354.519 177.289 337.298 133.099 337.298 133.099L325.131 130.835Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M278.477 309.55C260.884 388.642 252.747 470.355 252.747 470.355C252.747 470.355 217.996 460.494 185.028 455.16L149.006 445.485C147.844 444.958 135.351 439.19 131.306 435.189C127.059 430.972 124.718 442.57 131.399 447.857C133.414 449.454 134.979 450.865 136.25 452.09L127.57 453.439C126.082 453.672 124.687 454.323 123.571 455.346C117.526 460.82 97.8105 479.039 101.546 480.17C102.476 480.449 103.514 480.465 104.646 480.294C97.9035 485.861 97.3765 491.675 99.252 491.861C102.073 492.156 105.638 490.125 109.187 487.256C106.072 490.869 102.197 498.839 106.521 498.637C112.318 498.374 117.185 493.862 121.82 486.233C121.82 486.233 120.673 488.218 121.184 487.752L117.743 493.319C117.743 493.319 124.749 499.475 129.849 502.343C134.716 505.072 137.552 495.024 130.67 490.885C130.67 490.885 133.15 488.404 135.15 483.116C135.15 483.116 154.478 492.466 164.351 485.055L170.815 485.675C187.694 496.249 273.424 534.796 285.173 533.912C311.848 531.927 316.916 479.457 329.812 364.78C329.812 364.78 286.351 274.058 278.477 309.519V309.55Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.747 470.355C252.747 470.355 244.439 474.775 242.765 487.055",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M463.25 426.088C476.999 423.808 499.194 416.211 499.21 416.133C499.21 416.133 490.7 308.852 463.638 277.081C462.258 274.12 457.717 267.995 443.193 265.856C438.885 265.22 434.653 264.429 430.592 263.561C416.394 260.506 404.831 256.258 401.53 254.165C401.53 254.165 401.545 254.289 401.576 254.49C401.499 254.444 401.406 254.397 401.328 254.351C401.328 254.351 401.979 257.219 400.956 260.568C400.863 260.863 400.77 261.157 400.646 261.468C400.6 261.592 400.538 261.731 400.476 261.855C400.259 262.336 400.026 262.832 399.732 263.313C395.299 270.631 365.896 273.577 336.508 258.041C336.508 258.041 286.025 286.679 272.571 296.618C251.925 340.622 243.06 439.996 243.06 435.375C243.06 434.119 285.126 456.168 312.468 457.362C312.623 465.161 305.772 563.666 305.772 563.666C305.772 563.666 424.656 569.745 477.324 541.711C477.324 541.711 456.57 472.542 459.003 453.238C459.298 450.958 462.615 431.716 463.188 426.088H463.25Z",
    fill: "#EC7C1C",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M306.159 97.9175C306.159 97.9175 247.942 84.3348 251.6 99.3285C255.258 114.322 270.324 127.409 270.324 127.409C270.324 127.409 253.165 126.974 262.171 135.688C271.176 144.402 278.709 143.751 278.709 143.751L306.159 97.9175Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M334.555 231.837C334.555 231.837 340.538 230.333 351.527 220.782",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M345.281 161.288C345.281 161.288 341.235 86.2419 301.804 95.452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M368.821 182.896C369.719 168.967 359.436 156.965 345.853 156.088C332.27 155.212 320.531 165.794 319.633 179.723C318.735 193.652 329.018 205.655 342.601 206.531C356.184 207.407 367.923 196.826 368.821 182.896Z",
    fill: "#EC7C1C",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M360.827 182.003C360.176 192.004 352.178 199.633 342.941 199.043C333.703 198.454 326.743 189.849 327.379 179.848C328.03 169.847 336.028 162.218 345.265 162.807C354.503 163.397 361.463 172.002 360.827 182.003Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M290.086 174.049C290.101 176.064 291.372 177.692 292.922 177.677C294.472 177.677 295.712 176.018 295.697 174.002C295.681 171.986 294.41 170.358 292.86 170.374C291.31 170.374 290.07 172.033 290.086 174.049Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M303.788 163.443C301.525 160.342 298.316 159.241 295.759 158.419C292.922 157.504 290.132 156.59 288.939 157.908C288.226 158.698 288.179 160.187 288.799 161.117C289.652 162.435 291.574 162.373 293.372 162.559C300.331 163.288 304.315 167.459 305.105 166.435C305.555 165.846 304.408 164.28 303.803 163.443H303.788Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M290.598 210.3C290.598 210.3 298.239 209.99 303.214 204.889",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M261.628 87.0482C262.14 86.9861 285.08 80.7375 302.455 100.367",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M399.205 101.174L397.438 119.067C397.438 119.067 402.041 110.198 411.171 116.183",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M284.506 120.586C284.506 120.586 265.054 148.077 274.974 148.031C289.962 147.953 304.78 128.463 302.067 127.455C299.355 126.447 284.506 120.602 284.506 120.602V120.586Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.188 487.256L116.813 471.1L125.059 464.556",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M109.188 487.256L116.813 471.1L125.059 464.556",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M104.63 480.294L113.465 470.293",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M136.219 466.557L126.361 473.55L121.184 487.768",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M136.219 466.557L126.361 473.55L121.184 487.768",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M272.618 296.618C272.618 296.618 335.392 281.082 333.997 360.624L331.114 455.982C331.114 455.982 319.396 458.401 307.213 456.974",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M136.234 452.075L147.007 450.54",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M252.747 238.179C252.747 240.287 251.042 241.993 248.934 241.993C246.826 241.993 245.121 240.287 245.121 238.179C245.121 236.07 246.826 234.364 248.934 234.364C251.042 234.364 252.747 236.07 252.747 238.179Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M432.793 210.409C432.793 212.517 431.088 214.223 428.98 214.223C426.872 214.223 425.167 212.517 425.167 210.409C425.167 208.3 426.872 206.594 428.98 206.594C431.088 206.594 432.793 208.3 432.793 210.409Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M208.944 120.106C208.944 122.214 207.239 123.92 205.131 123.92C203.023 123.92 201.318 122.214 201.318 120.106C201.318 117.997 203.023 116.291 205.131 116.291C207.239 116.291 208.944 117.997 208.944 120.106Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9648 230.566C70.9648 232.674 69.2598 234.38 67.1518 234.38C65.0438 234.38 63.3389 232.674 63.3389 230.566C63.3389 228.457 65.0438 226.751 67.1518 226.751C69.2598 226.751 70.9648 228.457 70.9648 230.566Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M171.683 192.857C176.565 192.593 180.44 188.577 180.44 183.631C180.44 178.685 176.302 174.39 171.202 174.39C170.272 174.39 169.373 174.529 168.521 174.793C166.955 168.343 161.158 163.536 154.214 163.536C147.27 163.536 141.582 168.25 139.954 174.622C139.303 174.467 138.621 174.39 137.924 174.39C132.824 174.39 128.686 178.53 128.686 183.631C128.686 188.732 132.437 192.469 137.195 192.841H171.698L171.683 192.857Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M219.221 33.0897C224.305 32.8261 228.35 28.6242 228.35 23.4609C228.35 18.2976 224.026 13.8166 218.694 13.8166C217.717 13.8166 216.787 13.9561 215.904 14.2352C214.261 7.4904 208.216 2.48218 200.977 2.48218C193.739 2.48218 187.787 7.41287 186.082 14.0647C185.4 13.9096 184.687 13.8166 183.959 13.8166C178.627 13.8166 174.302 18.1426 174.302 23.4609C174.302 28.7792 178.224 32.6866 183.184 33.0742H219.19L219.221 33.0897Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M373.77 0.543945V4.91645",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M359.82 8.25L363.617 10.4363",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M359.51 24.1741L363.292 21.9878",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M373.149 32.4229V28.0349",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M387.099 24.7168L383.317 22.5305",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M387.409 8.79272L383.627 10.979",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M113.543 68.0232V72.3957",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5933 75.7139L103.391 77.9001",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2832 91.6533L103.081 89.467",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M112.923 99.8867V95.5142",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M126.873 92.196L123.091 90.0098",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M127.183 76.2566L123.401 78.4428",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M145.007 252.18V256.552",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M131.058 259.871L134.84 262.057",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M130.748 275.81L134.53 273.624",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M144.387 284.043V279.671",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M158.337 276.353L154.54 274.151",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.647 260.413L154.85 262.6",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPik1);
export default __webpack_public_path__ + "static/media/pik1.fc0efbbe3570abc79b41d09035011006.svg";
export { ForwardRef as ReactComponent };